import { supabase } from './supabase'

export const PSEUDO_DOMAIN = '@residents.bims.local'

const RESERVED_USERNAMES = new Set([
  'admin', 'root', 'superadmin', 'system', 'test', 'null', 'undefined',
])

export type UsernameValidationResult = { ok: true } | { ok: false; reason: string }

export function validateUsername(input: string): UsernameValidationResult {
  const u = input.toLowerCase().trim()
  if (u.length < 4) return { ok: false, reason: 'Username must be at least 4 characters' }
  if (u.length > 24) return { ok: false, reason: 'Username must be at most 24 characters' }
  if (!/^[a-z0-9_.]+$/.test(u)) return { ok: false, reason: 'Only lowercase letters, digits, underscore, and dot allowed' }
  if (/\.\./.test(u)) return { ok: false, reason: 'Username cannot contain consecutive dots' }
  if (/^[._]|[._]$/.test(u)) return { ok: false, reason: 'Username cannot start or end with dot or underscore' }
  if (RESERVED_USERNAMES.has(u)) return { ok: false, reason: 'This username is reserved' }
  if (u.startsWith('bims_')) return { ok: false, reason: 'Username cannot start with "bims_"' }
  return { ok: true }
}

export function usernameToEmail(username: string): string {
  return username.toLowerCase().trim() + PSEUDO_DOMAIN
}

export function emailToUsername(email: string): string {
  return email.replace(PSEUDO_DOMAIN, '')
}

export async function registerWithUsername(username: string, password: string) {
  const email = usernameToEmail(username)
  return supabase.auth.signUp({
    email,
    password,
    options: { emailRedirectTo: undefined },
  })
}

export async function loginWithUsername(username: string, password: string) {
  const email = usernameToEmail(username)
  return supabase.auth.signInWithPassword({ email, password })
}

export async function logout() {
  return supabase.auth.signOut()
}
